module.exports = __webpack_public_path__ + "img/a01a152.svg";